import SessionStatusUpdater from "@kaspernj/api-maker/build/session-status-updater.js"

const sessionStatusUpdater = SessionStatusUpdater.current()

sessionStatusUpdater.updateSessionStatus = async() => {
  const csrfTokenAtRequestStart = document.querySelector("meta[name='csrf-token']")?.getAttribute("content")
  const result = await sessionStatusUpdater.sessionStatus()
  const currentCsrfToken = document.querySelector("meta[name='csrf-token']")?.getAttribute("content")

  // Authentication rotates this token, so older responses no longer describe the current session.
  if (currentCsrfToken != csrfTokenAtRequestStart) return

  sessionStatusUpdater.updateMetaElementsFromResult(result)
  sessionStatusUpdater.updateUserSessionsFromResult(result)
}
